const appendToFormData = (formData, data, parentKey = "") => {
  if (typeof data === "object" && data !== null) {
    // If the data is an object or array, iterate over its keys or indices
    Object.entries(data).forEach(([key, value]) => {
      // Construct the key in bracket notation if parentKey is present
      const newKey = parentKey ? `${parentKey}[${key}]` : key;
      appendToFormData(formData, value, newKey);
    });
  } else {
    // If the data is a primitive value, append it to the FormData
    formData.append(parentKey, data);
  }
};

export default appendToFormData;
